import { MailIcon } from 'lucide-react';
import { useNamespaceCopy } from '@/i18n/ns';
import renderKitCopy from '@/i18n/ns/render-kit';
import { EmailMessage } from './email-message';
import type { EmailView } from './email-model';

/** render_email: one received email, read from the person's own account. */
export function EmailCard({ email }: { email: EmailView }) {
  const copy = useNamespaceCopy(renderKitCopy);
  return (
    <article className="pc-email-card" data-renderer="email" aria-label={copy.emailCard}>
      <header className="pc-email-head">
        <MailIcon aria-hidden="true" />
        <h3 className="pc-email-subject">{email.subject || copy.noSubject}</h3>
      </header>
      <EmailMessage email={email} />
    </article>
  );
}
